import * as React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { TokenType, useAuth } from '../../contexts';

type ProtectedRouteProps = {
  children: React.ReactNode;
  redirectPath: string;
};
export const ProtectedRoute = (props: ProtectedRouteProps): React.ReactNode => {
  const { redirectPath, children } = props;
  const { isTokenValid, user, logout } = useAuth();

  const location = useLocation();
  const isValid = isTokenValid();

  /** user who have not logged in */
  // academic staff have the right to enter
  if (!isValid || user?.tokenType === TokenType.GUEST) {
    logout();
    return <Navigate to={redirectPath} replace state={{ from: location }} />;
  }

  return children;
};
